/*
 * deferred-media.js — hidrata imágenes diferidas (data-src/data-srcset) de carruseles.
 *
 * Los slides de un carrusel Flickity en modo fade quedan apilados ocupando el
 * viewport, así que loading="lazy" nativo NO difiere nada: el navegador baja
 * los 6 slides del hero (~1.3MB móvil) aunque solo se vea el primero.
 *
 * image-fill.liquid (param defer: true) renderiza esos slides con data-srcset
 * y un SVG data-URI como src. Aquí se hidratan a la primera señal de
 * interacción con el slider (hover, touch, click o foco por teclado — cubre
 * flechas, dots y swipe). Con autoplay apagado un slide no-primero jamás se
 * muestra sin interacción previa, por eso el defer solo se emite cuando
 * autoplay está OFF (guard en section-slideshow.liquid).
 */
(function () {
  'use strict';

  if (window.__ukDeferredMedia) return;
  window.__ukDeferredMedia = true;

  function hydrate(root) {
    root.querySelectorAll('source[data-srcset]').forEach(function (source) {
      source.setAttribute('srcset', source.getAttribute('data-srcset'));
      source.removeAttribute('data-srcset');
    });

    root.querySelectorAll('img[data-src], img[data-srcset]').forEach(function (img) {
      var srcset = img.getAttribute('data-srcset');
      var src = img.getAttribute('data-src');
      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-srcset');
      }
      if (src) {
        img.setAttribute('src', src);
        img.removeAttribute('data-src');
      }
    });

    root.removeAttribute('data-deferred-media');
  }

  function onInteraction(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var slider = target.closest('slideshow-component');
    if (!slider) return;

    var deferred = slider.querySelectorAll('[data-deferred-media]');
    deferred.forEach(hydrate);
  }

  ['pointerover', 'pointerdown', 'touchstart', 'focusin'].forEach(function (type) {
    document.addEventListener(type, onInteraction, { capture: true, passive: true });
  });
})();
